import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LeftMenuService {
  expand$: BehaviorSubject<string> = new BehaviorSubject<string>('');

  onExpand() {
    return this.expand$.asObservable();
  }

  expand(target: string) {
    this.expand$.next(target);
  }

  constructor() {}
}
